import { Component, EventEmitter, Input, Output, ViewChild } from '@angular/core';
import { MatPaginator, PageEvent } from '@angular/material/paginator';
import { MatSort, Sort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import {
  formatOrderCommissionLabel,
  formatOrdersReportStatus,
  ORDERS_REPORT_COLUMNS,
  OrdersAvailableReportRow
} from 'src/entities/order';

@Component({
  selector: 'app-orders-report-table',
  templateUrl: './orders-report-table.component.html',
  styleUrls: ['./orders-report-table.component.css']
})
export class OrdersReportTableComponent {
  readonly displayedColumns = [...ORDERS_REPORT_COLUMNS];
  readonly formatStatus = formatOrdersReportStatus;
  readonly commissionLabel = formatOrderCommissionLabel;

  dataSource = new MatTableDataSource<OrdersAvailableReportRow>([]);

  @Input() set rows(value: OrdersAvailableReportRow[]) {
    this.dataSource.data = value ?? [];
  }

  @Input() isLoading = false;
  @Input() isLoadingMore = false;
  @Input() loadedCount = 0;
  @Input() totalCount = 0;

  @Output() openPdf = new EventEmitter<OrdersAvailableReportRow>();
  @Output() pageChange = new EventEmitter<PageEvent>();
  @Output() sortChange = new EventEmitter<Sort>();

  @ViewChild(MatPaginator) set paginator(value: MatPaginator) {
    this.dataSource.paginator = value;
  }

  @ViewChild(MatSort) set sort(value: MatSort) {
    this.dataSource.sort = value;
    this.dataSource.sortingDataAccessor = (item, property) => {
      switch (property) {
        case 'fileNumber':
          return item.numberFile ?? '';
        case 'numberOS':
          return item.numberOS ?? '';
        case 'estadoOS':
          return item.estadoOS ?? '';
        case 'nameProveedor':
          return item.nameProveedor ?? '';
        case 'paymentCondition':
          return item.paymentCondition ?? '';
        case 'serviceType':
          return item.serviceTypes?.join(' ') ?? '';
        case 'scheduledPaymentDate':
          return item.scheduledPaymentDate ?? '';
        case 'fechaPago':
          return item.fechaPago ?? '';
        case 'totalGeneral':
          return Number(item.totalGeneral) || 0;
        case 'currency':
          return item.currency ?? '';
        default:
          return (item as any)[property] ?? '';
      }
    };
  }

  get visibleCount(): number {
    return this.totalCount || this.dataSource.data?.length || 0;
  }

  statusPillClass(status: string | null | undefined): string {
    const key = formatOrdersReportStatus(status).toUpperCase().replace(/\s+/g, '');
    if (key === 'PRELIMINAR') return 'pill-preliminar';
    if (key === 'CONFIRMADO') return 'pill-confirmado';
    if (key === 'PAGADO') return 'pill-pagado';
    if (key === 'PROCESADO') return 'pill-procesado';
    if (key === 'ENPROCESO') return 'pill-proceso';
    if (key === 'ENESPERA') return 'pill-espera';
    if (key === 'CANCELADO' || key === 'DENEGADO' || key === 'RECHAZADO')
      return 'pill-cancelado';
    if (key === 'ELIMINADO') return 'pill-eliminado';
    if (key === 'NOTACREDITO') return 'pill-notacredito';
    return '';
  }

  onSort(sort: Sort): void {
    this.sortChange.emit(sort);
  }

  onPage(event: PageEvent): void {
    this.pageChange.emit(event);
  }
}
